import React from 'react';
import { connect } from "react-redux";

import Input from '@components/Input';
import Controls from "@components/Controls";

import { addMasonryResult, removeMasonryResult, updateMasonryResult } from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../../../../../texts/texts';
import { unitLabel, unitTransform } from '@services/helper.service';

import materialTabService from "@services/requests/material-tab.service";
import { defaultUnits, APP_STATES } from '@config';
import './styles.scss';

class ResultsTable extends React.Component {

  state = {
    selectedItems: [],
    resistanceData: {
      n1Test: 0,
      v1Test: 0
    },
  };

  componentDidMount() {
    this.getResistance(this.props.data);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.appStatus === APP_STATES.LOADING_NEW_STATE && this.props.appStatus !== APP_STATES.LOADING_NEW_STATE) {
      this.getResistance(this.props.data);
    }
  }

  render() {
    return (
      <div className="ml-2 mr-2">
        <div className="d-inline">
          <Controls
            onAdd={() => {
              this.props.addResult();
              this.getResistance([ ...this.props.data, { tensile: 0, shear: 0}]);
              }
            }
            onRemove={this.removeSelected}
            canRemove={this.isRemoveAllow()}
          />

          <span className="ml-2 align-text-bottom"><b>{APP_TEXTS.MASONRY_RESULTS_INFO.Content}</b></span>
        </div>

      {this.props.data && this.props.data.length > 0 && (
        <table className="masonry-table">
          <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={this.isAllSelected()}
                onChange={e => this.toggleAll(e.target.checked)}
              />
            </th>
            <th/>
            <th>{APP_TEXTS.CALCULATE_HEADER_TENSILE.Content}</th>
            <th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
          </tr>
          </thead>
          <tbody>
          {this.props.data.map((i, index) => (
            <tr key={i.id}>
              <td>
                <input
                  type="checkbox"
                  checked={this.isSelected(i.id)}
                  onClick={() => this.toggleSelect(i.id)}
                />
              </td>
              <td>
                <span>{APP_TEXTS.RESULTS_TABLE_RESULT.Content} {index + 1}</span>
              </td>
              <td>
                <Input
                  id={`tensile_${index}`}
                  value={unitTransform(i.tensile || 0).from(defaultUnits.LOAD).to(this.props.loadUnit)}
                  type="number"
                  onUpdate={value => {
                    let newVal = unitTransform(+value || 0, false).from(this.props.loadUnit).to(defaultUnits.LOAD);
                    this.props.updateResult(index, {
                      tensile: newVal
                    });

                    this.getResistance(this.props.data.map((item, idx) => {
                      let temp = Object.assign({}, item);
                      if (idx === index) 
                        temp.tensile = newVal;
                      return temp;
                    }));
                  }}
                />
              </td>
              <td>
                <Input
                  id={`shear_${index}`}
                  value={unitTransform(i.shear || 0).from(defaultUnits.LOAD).to(this.props.loadUnit)}
                  type="number"
                  onUpdate={value => {
                    let newVal = unitTransform(+value || 0, false).from(this.props.loadUnit).to(defaultUnits.LOAD);
                    this.props.updateResult(index, {
                      shear: newVal
                    });

                    this.getResistance(this.props.data.map((item, idx) => {
                      let temp = Object.assign({}, item);
                      if (idx === index) 
                        temp.shear = newVal;
                      return temp;
                    }));
                  }}
                />
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      )}
        <div className="list-type">
          <h4>{APP_TEXTS.EVALUATION_OF_TESTS.Content}</h4>

          <Input
            className="d-flex align-items-center label"
            prefix={APP_TEXTS.MASONRY_RESULTS_TABLE_N1TEST.Content} //"N1test"
            postfix={unitLabel(this.props.loadUnit)}
            id="n1test"
            type="number"
            disabled={true}
            value={unitTransform(this.state.resistanceData.n1Test || 0).from(defaultUnits.LOAD).to(this.props.loadUnit)}
          />

          <Input
            className="d-flex align-items-center label"
            prefix={APP_TEXTS.MASONRY_RESULTS_TABLE_V1TEST.Content} //"V1test"
            postfix={unitLabel(this.props.loadUnit)}
            id="v1test"
            type="number"
            disabled={true}
            value={unitTransform(this.state.resistanceData.v1Test || 0).from(defaultUnits.LOAD).to(this.props.loadUnit)}
          />
        </div>
      </div>
    );
  }

  isRemoveAllow() {
    return this.state.selectedItems.length !== 0;
  }

  isAllSelected() {
    return this.props.data.length !== 0 && this.state.selectedItems.length === this.props.data.length;
  }

  toggleAll(isActive) {
    this.setState({
      selectedItems: isActive ? this.props.data.map(i => i.id) : []
    });
  }

  toggleSelect(id) {
    if (this.isSelected(id)) {
      this.setState(prevState => ({
        selectedItems: prevState.selectedItems.filter(i => i !== id)
      }));
    } else {
      const items = [...this.state.selectedItems, id];
      this.setState({
        selectedItems: items
      });
    }
  }

  isSelected(id) {
    return this.state.selectedItems.indexOf(id) > -1;
  }

  removeSelected = () => {
    this.props.removeSelected(this.state.selectedItems);
    this.setState({
      selectedItems: []
    });
    this.getResistance(this.props.data.filter(result => !this.state.selectedItems.includes(result.id)));
  };

  getResistance = (data) => {
    if (data.hasOwnProperty('length') && 0 < data.length){
      materialTabService.getMasonryMaterialDesignResistance(data).then(res => {
        if (res) {
          this.setState({
            resistanceData: {
              n1Test: res.n1Test,
              v1Test: res.v1Test
            }
          });
        }
      });
    }
  }

}

const mapState = state => ({
  data: state.selectors.material[state.main.appType].masonry.jobSiteTest.results,
  loadUnit: state.main.units.load,
  appStatus: state.main.status
});

const mapDispatch = dispatch => ({
  addResult: () => dispatch(addMasonryResult()),
  updateResult: (index, value) => dispatch(updateMasonryResult(index, value)),
  removeSelected: toRemove => dispatch(removeMasonryResult(toRemove))
});

export default connect(mapState, mapDispatch)(ResultsTable);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/components/JobSiteTest/components/ResultsTable/index.js